import { Description, DescriptionProps } from "../../adviceStyled";

import styled from "styled-components";

export const AdviceIntroDesc = styled(Description)<DescriptionProps>`
  margin: 0;
`;

export const AdviceMessageStyle = styled.div`
  margin: 24px 0;
`;

export const WhiteSurface = styled.div`
  background: #fff;
  padding: 8px 16px;
`;
